import { render } from "./UserDetails.vue?vue&type=template&id=6ca464fe&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=ts"
export * from "./UserDetails.vue?vue&type=script&lang=ts"

import "./UserDetails.vue?vue&type=style&index=0&id=6ca464fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ca464fe"

export default script